import instance from "./request";


//新增分包单位
export const addCompany = (data) => instance.post('/company/add', data)
//修改分包单位
export const editCompany = (data) => instance.post('/company/edit', data)
//分包单位详情
export const companyInfo = (id) => instance.get('/company/info/' + id)
//批量导入分包单位
export const batchAdd = (data) => instance.post('/company/batchAdd', data)
//获取某项目下所有单位列表
export const companyAll = () => instance.get('/company/all')